import { Box, Flex, MantineTheme, Text, createStyles } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import clsx from "clsx"
import { FC, ReactElement } from "react"

const useStyles = createStyles((theme: MantineTheme) => ({
  box: {
    height: 41,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: 21,
    cursor: "pointer",
    boxSizing: "border-box",
    [theme.fn.smallerThan("sm")]: {
      padding: "0 1rem",
      width: "auto",
    },
  },
  active: {
    backgroundColor: "#F7F7F7",
    "& > div": {
      fontWeight: "bold",
    },
    [theme.fn.smallerThan("sm")]: {
      background: theme.colors.green[7],
      color: "#FFF",
    },
  },
}))

interface Props {
  list: {
    title: string
    component: ReactElement
  }[]
  activePage: string
  onChange: (title: string) => void
}

export const Info: FC<Props> = ({ list, activePage, onChange }) => {
  const { classes } = useStyles()

  const onClick = (info: string) => {
    onChange(info)
  }

  const isResponsive = useMediaQuery("(max-width: 48em)")

  return (
    <Flex
      p={0}
      m={0}
      w={"100%"}
      direction={"column"}
      sx={theme => ({
        [theme.fn.smallerThan("sm")]: {
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "0.5rem",
          justifyContent: "center",
        },
      })}
    >
      {list.map(({ title }, k: number) => (
        <Box
          key={k}
          className={clsx(classes.box, title === activePage ? classes.active : "")}
          onClick={() => onClick(title)}
        >
          <Text fw={400} fz={isResponsive ? 12 : 14}>
            {title}
          </Text>
        </Box>
      ))}
    </Flex>
  )
}
